import ChannelAdaptationsToolbar from "./ChannelAdaptationsToolbar";

export default ChannelAdaptationsToolbar;
